import React from 'react';

const Header = () => {
  return (
    <React.Fragment>
      <section id='banner' className='major'>
        <div className='inner'>
          <img
            src='logo.jpg'
            alt='Random User'
            title='leading view'
            width='150'
            height='150'
            style={{borderRadius: '50%'}}
          />
          <header className='major'>
            <h1>Hi, I am Esther Folabomi</h1>
          </header>
          <div className='content'>
            <p>
              A specialty designer & A Linguistic graduate, I make bridal & reception dresses, as well as
              official, casual & traditional outfits.
            </p>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Header;
